import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const DOMReaderOutlined: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
      fill="currentColor"
    />
    <path d="M13 12.5V11H11.5V12.5H13Z" fill="currentColor" />
    <path
      d="M11 18H13.5C14.05 18 14.5 17.55 14.5 17V14.5C14.5 13.95 14.05 13.5 13.5 13.5H11C10.45 13.5 10 13.95 10 14.5V17C10 17.55 10.45 18 11 18ZM11.5 15H13V16.5H11.5V15Z"
      fill="currentColor"
    />
    <path d="M13 10V8.5H11.5V10H13Z" fill="currentColor" />
    <path d="M13 7.5V6H11.5V7.5H13Z" fill="currentColor" />
  </SvgIcon>
);

export default DOMReaderOutlined;
